import { useContext } from 'react';
import invariant from 'tiny-invariant';
import GlobalizeContext from '../GlobalizeProvider/GlobalizeContext';
export default function useChangePreferredLocale() {
  var ctx = useContext(GlobalizeContext);
  invariant(ctx, "Using of 'useChangePreferredLocale' is allowed only inside of 'GlobalizeProvider'.");
  return ctx.changePreferredLocale;
}